<template>
  <div class="userinfo-page">
    <div class="userinfo-panel">
      <el-tabs v-model="index"
               class="userinfo-tabs"
               type="card"
               @tab-click="handleClick">
        <el-tab-pane label="修改个人信息"
                     name="0">
          <avue-form :option="option.group[0]"
                     v-model="form"
                     @tab-click="handleTabClick"
                     @submit="handleSubmit"></avue-form>
        </el-tab-pane>
        <el-tab-pane label="修改密码"
                     name="1">
          <avue-form :option="option.group[1]"
                     v-model="form"
                     @tab-click="handleTabClick"
                     @submit="handleSubmit"></avue-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import option from "@/option/user/info";
import { getUserInfo, updateInfo, updatePassword } from "@/api/system/user";
import md5 from 'js-md5';
import func from "@/util/func";
import validate from "@/util/validate";


export default {
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      index: '0',
      option: {
        tabs: true,
        tabsActive: 1,
        group: [
          {
            label: '个人信息',
            prop: 'info',
            column: [{
              label: '头像',
              type: 'upload',
              listType: 'picture-img',
              propsHttp: {
                res: 'data',
                url: 'link',
              },
              canvasOption: {
                text: ' ',
                ratio: 0.1
              },
              action: '/api/blade-resource/oss/endpoint/put-file',
              tip: '只能上传jpg/png用户头像，且不超过500kb',
              span: 12,
              row: true,
              prop: 'avatar'
            }, {
              label: '用户昵称',
              span: 12,
              row: true,
              prop: 'name',
              rules: [
                {
                  required: true,
                  message: '请输入用户昵称',
                  trigger: 'blur',
                },
              ],
            }, {
              label: '用户姓名',
              span: 12,
              row: true,
              prop: 'realName',
              rules: [
                {
                  required: true,
                  message: '请输入用户姓名',
                  trigger: 'blur',
                },
                {
                  min: 2,
                  max: 5,
                  message: '姓名长度在2到5个字符',
                },
              ],
            }, {
              label: '手机号',
              span: 12,
              row: true,
              prop: 'phone'
            }, {
              label: '邮箱',
              prop: 'email',
              span: 12,
              row: true,
            }]
          },
          {
            label: '修改密码',
            prop: 'password',
            column: [{
              label: '原密码',
              span: 12,
              row: true,
              type: 'password',
              prop: 'oldPassword'
            }, {
              label: '新密码',
              span: 12,
              row: true,
              type: 'password',
              prop: 'newPassword',
              rules: [{ required: true, validator: validate.password, trigger: 'blur' }]
            }, {
              label: '确认密码',
              span: 12,
              row: true,
              type: 'password',
              prop: 'newPassword1',
              rules: [{ required: true, validator: validatePass2, trigger: 'blur' }]
            }]
          }
        ],
      },
      form: {}
    };
  },
  created() {
    this.handleWitch();
    this.routerFlag = this.$route.query.jumpFlag
  },
  beforeDestroy() {
    if(this.routerFlag){  // 未更改密码，退出登录
      this.$store.dispatch("LogOut").then(() => {
        this.$router.push({ path: "/login" });
      });
    }
  },
  methods: {
    handleSubmit(form, done) {
      if (this.index === '0') {
        updateInfo(form).then(res => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "修改信息成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
          done();
        }, error => {
          window.console.log(error);
          done();
        })
      } else {
        updatePassword(md5(form.oldPassword), md5(form.newPassword), md5(form.newPassword1),form.newPassword1).then(res => {
          if (res.data.success) {
            this.routerFlag = false
            this.$message({
              type: "success",
              message: "修改密码成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
          done();
        }, error => {
          window.console.log(error);
          done();
        })
      }
    },
    handleWitch() {
      if (this.index === '0') {
        getUserInfo().then(res => {
          const user = res.data.data;
          this.form = {
            id: user.id,
            avatar: user.avatar,
            name: user.name,
            realName: user.realName,
            phone: user.phone,
            email: user.email,
          }
        });
      }
    },
    handleTabClick(tabs) {
      this.index = func.toInt(tabs.index);
      this.handleWitch();
    }
  }
};
</script>

<style lang="scss" scoped>
.userinfo-page {
  min-height: calc(100vh - 124px);
  padding: 10px 0 24px;
  background: #edf3fb;
}

.userinfo-panel {
  min-height: 208px;
  padding: 0 0 32px;
  background: #fff;
}

.userinfo-tabs {
  ::v-deep .el-tabs__header {
    margin: 0;
    padding-left: 0;
    background: #edf3fb;
    border-bottom: 1px solid #dfe7f2;
  }

  ::v-deep .el-tabs__nav {
    border-color: #d8e1ee;
  }

  ::v-deep .el-tabs__item {
    min-width: 126px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #1f2d3d;
    background: #f8fbff;
    border-color: #d8e1ee;
  }

  ::v-deep .el-tabs__item.is-active {
    color: #2f6df6;
    background: #fff;
    font-weight: 500;
  }

  ::v-deep .el-tabs__content {
    padding: 18px 24px 0;
  }

  ::v-deep .avue-form {
    max-width: 860px;
  }

  ::v-deep .avue-form__group {
    padding: 0;
  }

  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }

  ::v-deep .el-form-item.is-error {
    margin-bottom: 38px;
  }

  ::v-deep .el-form-item__error {
    max-width: 100%;
    line-height: 18px;
    white-space: normal;
    word-break: break-all;
  }

  ::v-deep .el-form-item__label {
    color: #344563;
    font-weight: 400;
  }

  ::v-deep .el-input__inner {
    height: 34px;
    line-height: 34px;
    border-color: #d5deeb;
  }

  ::v-deep .el-input__inner:focus {
    border-color: #2f6df6;
  }

  ::v-deep .avue-upload__avatar,
  ::v-deep .avue-upload .el-upload {
    border-color: #d8e1ee;
    background: #fbfdff;
  }

  ::v-deep .el-upload__tip {
    margin-top: 8px;
    color: #61728a;
  }

  ::v-deep .avue-form__menu {
    margin-top: 6px;
    padding-left: 86px;
    text-align: left;
  }

  ::v-deep .avue-form__menu .el-button {
    min-width: 76px;
    height: 34px;
    padding: 8px 18px;
    border-radius: 4px;
  }
}
</style>
